<template>
  <section class="w-full bg-[#373737]">
    <div class="py-[60px] md:py-[100px] md:container relative">
      <!-- Heading: Common for Both Image and Boxes -->
      <h1
        class="px-[15px] text-[22px] leading-8 md:text-4xl md:leading-10 font-bold text-center text-white uppercase font-ff-good-pro-cond"
        v-text="$t('common.warranty_guarantee_not_valid')"
      ></h1>

      <div
        class="w-full grid grid-cols-1 xl:grid-cols-11 gap-[24px] md:gap-[49px] font-ff-good-pro-cond"
      >
        <div class="px-[15px] md:px-0 md:order-1 order-2 xl:col-span-5">
          <ul class="divide-y divide-[#4C4C4C] my-0 lg:my-0">
            <li
              v-for="(step, index) in guaranteeStepsList"
              :key="index"
              class="py-[14px] md:py-4"
            >
              <div
                class="text-base leading-[22px] italic text-primary-500 font-bold"
              >
                {{ step.step }}
              </div>
              <div
                class="mt-1 text-white text-lg leading-6 lg:text-xl lg:leading-[26px] font-normal"
                v-text="$t(`${step.description}`)"
              ></div>
            </li>
          </ul>
        </div>
        <div
          class="flex items-center justify-center order-1 xl:col-span-6 md:order-2"
        >
          <img
            src="@/public/warranty/warranty_registration.png"
            alt="Arrow Point"
            class="w-[375px] h-[436px] object-cover sm:object-contain object-[-40px] sm:w-full sm:h-full sm:object-center xl:max-w-[723px] xl:absolute xl:right-0"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const guaranteeStepsList = ref([
  {
    step: "01",
    description: "common.warranty_guarantee_1",
  },
  {
    step: "02",
    description: "common.warranty_guarantee_2",
  },
  {
    step: "03",
    description: "common.warranty_guarantee_3",
  },
  {
    step: "04",
    description: "common.warranty_guarantee_4",
  },
  {
    step: "05",
    description: "common.warranty_guarantee_5",
  },
  {
    step: "06",
    description: "common.warranty_guarantee_6",
  },
  {
    step: "07",
    description: "common.warranty_guarantee_7",
  },
]);
</script>

<style scoped>
/* Custom styles for specific adjustments can be added here if needed */
</style>
